export default function ForumsHero() {
  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-purple-900/30 to-gray-900">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-10"></div>
        </div>
      </div>
      
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/a8a3d030bf9155fe05b3a56ce5233097.jpg"
          alt="Forums"
          className="w-full h-full object-cover object-center opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-purple-900/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="inline-flex items-center bg-purple-600/20 border border-purple-500/50 rounded-full px-5 py-2 mb-6 backdrop-blur-sm">
          <i className="ri-chat-3-line text-purple-400 mr-2"></i>
          <span className="text-purple-300 font-semibold text-sm">COMMUNITY FORUMS</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Join the <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Conversation</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
          Connect with players worldwide, share strategies, discuss tournaments, and become part of the Revenant League community
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <div className="relative w-full sm:w-96">
            <input
              type="text"
              placeholder="Search discussions..."
              className="w-full bg-gray-900/80 backdrop-blur-sm border border-purple-500/30 rounded-lg px-5 py-4 pl-12 text-white text-sm focus:outline-none focus:border-purple-500 transition-colors"
            />
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
          </div>
          <button className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg shadow-purple-500/50 cursor-pointer whitespace-nowrap">
            <i className="ri-add-line mr-2"></i>
            New Topic
          </button>
        </div>

        <div className="flex flex-wrap gap-6 justify-center">
          <div className="bg-gray-800/60 backdrop-blur-sm border border-purple-500/30 rounded-xl px-8 py-5 shadow-lg shadow-purple-500/20">
            <div className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-1">12.5K+</div>
            <div className="text-gray-400 text-sm">Active Members</div>
          </div>
          <div className="bg-gray-800/60 backdrop-blur-sm border border-purple-500/30 rounded-xl px-8 py-5 shadow-lg shadow-purple-500/20">
            <div className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-1">45K+</div>
            <div className="text-gray-400 text-sm">Discussions</div>
          </div>
          <div className="bg-gray-800/60 backdrop-blur-sm border border-purple-500/30 rounded-xl px-8 py-5 shadow-lg shadow-purple-500/20">
            <div className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-1">180K+</div>
            <div className="text-gray-400 text-sm">Posts</div>
          </div>
        </div>
      </div>
    </section>
  );
}
